import AuthProvider from "./auth"
import BannerProvider from "./banner"
import QueryProvider from "./query"

const AppProviders: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <BannerProvider>
      <QueryProvider>
        <AuthProvider>{children}</AuthProvider>
      </QueryProvider>
    </BannerProvider>
  )
}

export default AppProviders
